import { useState } from "react";
import { gerarPdfPorExames } from "./examsPdfService";

export const useExamsPdf = () => {
  const [carregando, setCarregando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState(null);

  const gerarPdf = async (exames) => {
    setCarregando(true);
    setErro(null);

    try {
      const result = await gerarPdfPorExames(exames);
      setResultado(result);
      return result;
    } catch (err) {
      const mensagemErro =
        err instanceof Error ? err.message : "Erro ao gerar PDF";
      setErro(mensagemErro);
      throw err;
    } finally {
      setCarregando(false);
    }
  };

  const limpar = () => {
    setResultado(null);
    setErro(null);
  };

  return {
    gerarPdf,
    carregando,
    resultado,
    erro,
    limpar,
  };
};

